module.exports = {
  menuHomeLabel: 'Home',
  menuBenefitsLabel: 'Vantagens',
  menuEarningsLabel: 'Ganhos como consultora',
  menuOurCausesLabel: 'Nossas Causas',
  menuHelpLabel: 'Ajuda',
  homeId: 'home',
  homeHeroSectionId: 'hero',
  homeHeroCTAButtonText: 'Clique aqui para se cadastrar',
  homeHeroCTAButtonAccessibleLabel: 'Cadastrar',
  homeHeroSubtitle:
    'Seja uma Consultora Natura e tenha lucros, prêmios e muito mais!',
  homeHeroTitle: 'Com a Consultoria<br />de Beleza Natura #VocêPodeMais',
  homeHeroImageAlt: 'Mulher sorrindo segurando um celular. Ao lado esquerdo, produtos da Natura em cima da mesa.',
  homePageTitle: 'Quero ser Consultora',
  benefitsSectionId: 'vantagens',
  benefitsHeadingTitle: 'Vantagens de ser uma Consultora Natura',
  benefitsHeadingSubtitle:
    'O que uma marca de beleza pode fazer pelas suas consultoras?',
  benefitHealthTitle: 'Saúde',
  benefitHealthText:
    'Cuide da saúde da sua família e da sua! Tenha consultas e exames em clínicas particulares, desconto em medicamentos e muito mais!',
  benefitEducationTitle: 'Educação',
  benefitEducationText:
    'Descontos exclusivos e cursos gratuitos para você e sua família. Mais de 80 opções de cursos entre: graduação e pós, idiomas e profissionalizante.',
  benefitOnlineSellsTitle: 'Vendas pela <br/> Internet',
  benefitOnlineSellsText:
    'Uma página exclusiva no site da Natura, para você divulgar e realizar a prestação do serviço de Consultoria de Beleza para os clientes, pela internet e sem sair de casa.',
  benefitBonusTitle: 'Ganhos <br/> Diferenciados',
  benefitBonusText:
    'As Consultoras Natura contam com plano de crescimento de 5 níveis (de Semente até Diamante) com lucros de até 35%!',
  benefitRecognitionTitle: 'Reconhecimento',
  benefitRecognitionText:
    'Prêmios, joias, concursos, carro, viagens e outros benefícios exclusivos para Consultoras de Beleza Natura.',
  benefitRegisterButtonText: 'Quero ser Consultora Natura',
  ctaButtonLinkDesktop: '/br/auto',
  ctaButtonLinkMobile: '/br/auto',
  earningsSectionId: 'ganhos-como-consultora',
  earningsHeadingTitle: 'Ganhos como Consultora',
  earningsHeadingSubtitle:
    'Veja como você lucra com um conjunto especial de produtos, na venda presencial ou pela internet:',
  earningsProduct1Title: 'Ekos Castanha',
  earningsProduct1Description: '100% vegano e ajuda a manter a floresta em pé',
  earningsProduct2Title: 'Tododia Flor de Lis',
  earningsProduct2Description: 'Nutrição prebiótica e ingredientes naturais',
  earningsProduct3Title: 'Essencial Supreme',
  earningsProduct3Description: 'A ousadia do Pará com a sofisticação de Paris',
  earningsProduct4Title: ' Lumina Máscara',
  earningsProduct4Description:
    'Biotecnologia pró-teia e frasco de plástico verde',
  earningsCalculatorChartResultText: 'Seu cliente compra esse conjunto por:',
  earningsCalculatorChartResultDescription:
    `{salesType, select, true {O lucro dessa venda presencial, de <br/> acordo com o nível da Consultora é:} false 
    {O ganho desta prestação de serviços de Consultoria de Beleza é calculado de acordo com o seu nível:}}`,
  earningsChartLevelSeed: 'Semente',
  earningsChartLevelBronze: 'Bronze',
  earningsChartLevelSilver: 'Prata',
  earningsChartLevelGold: 'Ouro',
  earningsChartLevelDiamond: 'Diamante',
  onlineSalesButtonText: 'Prestação de Serviços de Consultoria de Beleza pela Internet',
  regularSalesButtonText: 'Vendas Presenciais',
  ourCausesSectionId: 'nossas-causas',
  ourCausesHeadingTitle: 'Nossas Causas',
  ourCausesHeadingSubtitle: 'O que uma marca de beleza pode fazer pelo mundo?',
  ourCausesAmazonTitle: 'Amazônia Viva',
  ourCausesAmazonText:
    'Contribuímos na preservação de 1,8 milhão de <br/> hectares na Amazônia, o equivalente a 12 <br/> vezes a cidade de SP e 14 vezes a cidade do&nbsp;RJ.',
  ourCausesRecyclingTitle: 'Mais beleza, menos lixo',
  ourCausesRecyclingText:
    'Reutilizamos 432 toneladas de plástico nas <br/> embalagens, ou seja, por ano, 9 milhões de <br/> garrafas PET de 2 litros deixam de ir para o&nbsp;lixo.',
  phone: '0300 762 8872',
  helpSectionId: 'ajuda',
  helpHeadingTitle: 'Ajuda',
  footerTitle: 'Veja também',
  footerCallCenterLabel: 'Central de Relacionamento',
  footerCopyRightLabel: 'Todos os direitos reservados.'
}
